<template>
    <vx-card :title='$t("Notifications")' collapse-action>
        <div>
            <vs-table v-model="selected" @selected="handleSelected" search :data="notificationTags">

                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                    <div class="flex flex-wrap-reverse items-center mb-3">
                        <vs-button type="border" color="success" icon-pack="feather" icon="icon-plus-circle" @click="addNotificationsPrompt = true">{{$t("Add")}}</vs-button>
                    </div>

                </div>

                <template slot="thead">
                    <vs-th sort-key="priority">{{$t("Priority")}}</vs-th>
                    <vs-th sort-key="sms">{{$t("SMS")}}</vs-th>
                    <vs-th sort-key="mail">{{$t("Email")}}</vs-th>
                    <vs-th sort-key="tags">{{$t("Tags")}}</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >

                        <vs-td :data="data[indextr].priority">
                            {{data[indextr].priority}}
                        </vs-td>

                        <vs-td :data="sms">
                            {{(data[indextr].sms) ? $t('Yes') : $t('No')}}
                        </vs-td>

                        <vs-td :data="mail">
                            {{(data[indextr].mail) ? $t('Yes') : $t('No')}}
                        </vs-td>

                        <vs-td :data="data[indextr].tags">
                            <vs-chip class="mr-3 mt-3" :color="item.color" :key="index" v-for="(item,index) in data[indextr].tags">
                                <p v-bind:style="{color: item.text_color}"><b>{{ item.name}}</b></p>
                            </vs-chip>
                        </vs-td>

                    </vs-tr>
                </template>
            </vs-table>
        </div>

        <vs-popup :title="$t('Add')" :active.sync="addNotificationsPrompt">
            <vx-card>
                <div>

                    <p class="mt-6">{{$t("Tags")}}</p>
                    <v-select class="selectStyle" multiple style="width: 100%" :options="this.$store.state.tagsArray" label="name" v-model="addNotificationObject['tags']">
                        <template slot="option" slot-scope="option">
                            <div style="display: flex">
                                <vs-chip :color="option.color" style="margin: auto">
                                    <p v-bind:style="{color: option.text_color}"><b>{{ option.name}}</b></p>
                                </vs-chip>
                            </div>
                        </template>
                    </v-select>

                    <p class="mt-6">{{$t("Priority")}}</p>
                    <vs-select autocomplete class="selectExample" v-model="addNotificationObject['priority']">
                        <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in [{id:1, name:1}, {id:2, name:2}, {id:3, name:3}, {id:4, name:4}, {id:5, name:5}]" />
                    </vs-select>

                    <div class="vx-row mt-6">
                        <div class="vx-col w-full xl:w-1/2 lg:w-1/2 md:w-1/2">
                            <vs-checkbox class="mb-6" v-model="addNotificationObject['sms']">{{$t("SMS")}}</vs-checkbox>
                        </div>
                        <div class="vx-col w-full xl:w-1/2 lg:w-1/2 md:w-1/2">
                            <vs-checkbox class="mb-6" v-model="addNotificationObject['mail']">{{$t("Email")}}</vs-checkbox>
                        </div>

                    </div>

                    <vs-divider/>
                    <vs-button color="success" type="border" class="mt-6; mr-1" @click="addNotification">{{$t("Add")}}</vs-button>
                </div>
            </vx-card>
        </vs-popup>

        <vs-popup :title="$t('Edit')" :active.sync="editNotificationsPrompt">
            <vx-card>
                <div>
                    <p class="mt-6">{{$t("Tags")}}</p>
                    <v-select class="selectStyle" multiple style="width: 100%" :options="this.$store.state.tagsArray" label="name" v-model="editNotificationObject['tags']">
                        <template slot="option" slot-scope="option">
                            <div style="display: flex">
                                <vs-chip :color="option.color" style="margin: auto">
                                    <p v-bind:style="{color: option.text_color}"><b>{{ option.name}}</b></p>
                                </vs-chip>
                            </div>
                        </template>
                    </v-select>

                    <p class="mt-6">{{$t("Priority")}}</p>
                    <vs-select autocomplete class="selectExample" v-model="editNotificationObject['priority']">
                        <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in [{id:1, name:1}, {id:2, name:2}, {id:3, name:3}, {id:4, name:4}, {id:5, name:5}]" />
                    </vs-select>

                    <div class="vx-row mt-6">
                        <div class="vx-col w-full xl:w-1/2 lg:w-1/2 md:w-1/2">
                            <vs-checkbox class="mb-6" v-model="editNotificationObject['sms']">{{$t("SMS")}}</vs-checkbox>
                        </div>
                        <div class="vx-col w-full xl:w-1/2 lg:w-1/2 md:w-1/2">
                            <vs-checkbox class="mb-6" v-model="editNotificationObject['mail']">{{$t("Email")}}</vs-checkbox>
                        </div>

                    </div>

                    <vs-divider/>
                    <vs-button style="float: left" color="success" icon-pack="feather" icon="icon-edit" type="border" class="mt-6; mr-1" @click="editNotification">{{$t("Save")}}</vs-button>
                    <vs-button style="float: right" type="border" color="danger" icon-pack="feather" icon="icon-trash-2" @click="removeNotification">{{$t("Delete")}}</vs-button>
                    <div style="clear: both"></div>
                </div>
            </vx-card>
        </vs-popup>

    </vx-card>
</template>
<script>

    import vSelect from "vue-select";

    export default {
        props: {
            typeId: {
                type: Number,
                required: true
            },
        },
        components: {
            'v-select': vSelect,
        },
        data() {
            return {

                notificationTags: [],
                selected: {},
                addNotificationsPrompt: false,
                editNotificationsPrompt: false,

                addNotificationObject: {},
                editNotificationObject: {},

            }
        },
        watch: {
            editNotificationsPrompt: function () {
                if(!this.editNotificationsPrompt){
                    this.selected = {}
                }
            }
        },
        methods: {
            handleSelected(tr) {
                this.editNotificationObject = JSON.parse(JSON.stringify(tr));
                this.editNotificationsPrompt = true;
            },
            updateTags() {
                const thisIns = this;
                this.$http.get('/api/v1/user_type/' + this.typeId + '/notification_tag')
                    .then(function (response) {
                        thisIns.notificationTags = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            position:'top-right',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            addNotification() {
                const thisIns = this;
                this.$http.post('/api/v1/user_type/' + this.typeId + '/notification_tag', this.addNotificationObject
                ).then(function () {
                    thisIns.updateTags();
                    thisIns.addNotificationsPrompt = false;
                    thisIns.addNotificationObject = {};
                }).catch(function (error) {
                    thisIns.addNotificationsPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            editNotification() {
                const thisIns = this;
                this.$http.put('/api/v1/user_type/' + this.typeId + '/notification_tag/' + this.editNotificationObject.id, this.editNotificationObject
                ).then(function () {
                    thisIns.updateTags();
                    thisIns.editNotificationsPrompt = false;
                }).catch(function (error) {
                    thisIns.editNotificationObject = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            removeNotification() {
                const thisIns = this;
                this.$http.delete('/api/v1/user_type/' + this.typeId + '/notification_tag/' + this.editNotificationObject.id)
                    .then(function () {
                        thisIns.updateTags();
                        thisIns.editNotificationsPrompt = false;
                    }).catch(function (error) {
                    thisIns.editNotificationsPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            }
        },
        created() {
            this.updateTags();
        },
    }

</script>
